import { REFI_MFE_UUID, RefiHttpClient } from '@cof/refi-web-sdk';
import { REFI_LIENHOLDER_CONST } from '../../../shared/constants/app.constants.js';
import { SessionService } from '../session/session.service.js';
import { DebugService } from '../../../shared/services/debug.service.js';

class _ApiService {
  constructor() {
    this._client = new RefiHttpClient().withRetry(3);
    this.headers = { ...REFI_LIENHOLDER_CONST.HTTP_HEADERS };
    if (REFI_LIENHOLDER_CONST.isDevEnv) {
      this.headers['x-upstream-env'] = 'dev';
    } else if (REFI_LIENHOLDER_CONST.isSBEnv) {
      this.headers['x-upstream-env'] = 'sb';
    }
    if (sessionStorage.getItem(REFI_LIENHOLDER_CONST.C1_REFI_APPIDS)) {
      this.headers[REFI_LIENHOLDER_CONST.C1_REFI_APPIDS] = sessionStorage.getItem(REFI_LIENHOLDER_CONST.C1_REFI_APPIDS);
    }
    this.debug = new DebugService('ApiService');

    this.subscribers = [];
    this._test = {
      hostAppNavigation: true,
    };

    this.fetchWrapper = (url, opts, timeout = 0) => {
      this.debug.log(`${timeout <= 0 ? 'Not' : ''} using custom timeout${timeout > 0 ? ` of ${timeout}ms` : ''} for url ${url}`);
      return timeout > 0 ? this._client.withCustomTimeout(this._client.fetch(url, opts), timeout) : this._client.fetch(url, opts);
    };
  }

  set test({ hostAppNavigation = true }) {
    this.debug.log('setting test with api service with', { hostAppNavigation });
    this._test = {
      hostAppNavigation,
    };
    this.publish();
  }

  buildHeaders() {
    const id = REFI_MFE_UUID.makeUUID();
    const headers = {
      ...this.headers,
      'Client-Correlation-Id': id,
    };

    if (SessionService.session?.eAppId) {
      headers.eapp_id = SessionService.session.eAppId;
    }

    return headers;
  }

  async get(url, opts = {}, timeout = 0) {
    const headers = this.buildHeaders();
    return this.fetchWrapper(
      url,
      {
        headers,
        withCredentials: true,
        ...opts,
      },
      timeout,
    ).then(this.constructor._httpInterceptor);
  }

  async post(url, body, opts = {}, timeout = 0) {
    const headers = this.buildHeaders();
    const options = {
      ...opts,
      headers,
      withCredentials: true,
      method: 'POST',
      body: JSON.stringify(body),
    };
    return this.fetchWrapper(url, options, timeout).then(this.constructor._httpInterceptor);
  }

  static _httpInterceptor(res) {
    if (res.status === 204) {
      return res;
    }
    if (res.status >= 200 && res.status < 300) {
      return res.json();
    }
    if (res.status === 403) {
      document.dispatchEvent(new CustomEvent('refi-login-sign-out'));
    }
    if (res.status === 401) {
      document.dispatchEvent(new CustomEvent('refi-login-sign-out'));
    }
    return Promise.reject(res);
  }

  publish() {
    this.subscribers.forEach(subscriber => {
      subscriber.callback(this._test);
    });
  }

  subscribe(name, callback) {
    const index = this.subscribers.findIndex(subscriber => subscriber.name === name);
    if (index > -1) {
      this.subscribers[index] = { name, callback };
    } else {
      this.subscribers.push({ name, callback });
    }
    callback(this._test);
  }

  unsubscribe(name) {
    const index = this.subscribers.findIndex(subscriber => subscriber.name === name);
    if (index > -1) {
      this.subscribers.splice(index, 1);
    }
  }
}

export const ApiService = new _ApiService();
